export default "/images/vendor/flag-icon-css/flags/4x3/ea.svg?f1e55aacdee7ad81f5dac2e61d752efb";